/**
 * Throws if `condition` is falsy. After this returns,
 * TypeScript assumes `condition` is true (type-narrowing).
 */
export function assert(condition, msg) {
    if (!condition) {
        throw new Error(msg ?? 'Assertion failed');
    }
}
